import React from 'react';
import { useAmp } from 'next/amp';

const gaConfig = {
  vars: {
    account: 'UA-71297470-3',
  },
  triggers: {
    trackPageview: {
      on: 'visible',
      request: 'pageview',
      vars: {
        account: 'UA-71297470-3',
      },
    },
    trackPageview2: {
      on: 'visible',
      request: 'pageview',
      vars: {
        account: 'UA-71297470-9',
      },
    },
    setFbShareCd: {
      on: 'click',
      request: 'set',
      selector: '#fb-share-button',
      vars: {
        location: 'Fixed bottom footer',
      },
    },
    setWaShareCd: {
      on: 'click',
      request: 'set',
      selector: '#wa-share-button',
      vars: {
        location: 'Fixed bottom footer',
      },
    },
    setTelegramShareCd: {
      on: 'click',
      request: 'set',
      selector: '#telegram-share-button',
      vars: {
        location: 'Fixed bottom footer',
      },
    },
    setCopyLinkCd: {
      on: 'click',
      request: 'set',
      selector: '#copy-link-button',
      vars: {
        location: 'Fixed bottom footer',
      },
    },
    trackFbShare: {
      on: 'click',
      selector: '#fb-share-button',
      request: 'event',
      vars: {
        eventCategory: 'Social share',
        eventAction: 'click',
        eventLabel: 'Facebook',
      },
    },
    trackWaShare: {
      on: 'click',
      selector: '#wa-share-button',
      request: 'event',
      vars: {
        eventCategory: 'Social share',
        eventAction: 'click',
        eventLabel: 'WhatsApp',
      },
    },
    trackTelegramShare: {
      on: 'click',
      selector: '#telegram-share-button',
      request: 'event',
      vars: {
        eventCategory: 'Social share',
        eventAction: 'click',
        eventLabel: 'Telegram',
      },
    },
    trackCopyLink: {
      on: 'click',
      selector: '#copy-link-button',
      request: 'event',
      vars: {
        eventCategory: 'Social share',
        eventAction: 'click',
        eventLabel: 'Copy Link',
      },
    },
  },
};

const pixelConfig = {
  vars: {
    pixelId: '1090273721022565',
  },
  triggers: {
    trackPageview: {
      on: 'visible',
      request: 'pageview',
    },
  },
};

const isProd = process.env.NODE_ENV === 'production';

const AmpAnalytics = () => {
  const isAmp = useAmp();
  if (!isProd || !isAmp) return null;
  return (
    <>
      <amp-analytics type="googleanalytics" id="googleanalytics">
        <script
          type="application/json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(gaConfig),
          }}
        />
      </amp-analytics>
      <amp-analytics type="facebookpixel" id="facebook-pixel">
        <script
          type="application/json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(pixelConfig),
          }}
        />
      </amp-analytics>
    </>
  );
};

export default AmpAnalytics;
